import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import colors from "../../../styles/colors";
import AppFrame from "../../Appframe/AppFrame";
import Title from "../../../components/common/Title";
import * as actionCreators from "../../../actions/apps";
import CSATReport from "../../../components/report/CSATReport";
import CSATScore from "../../../components/report/CSATScore";
import CSATService from "../../../services/csat";
import { Icon } from "@material-ui/core";

const style = {};

class CSATRatingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportAppId: props.apps.providerAppId,
      practiceScore: null,
      providerScore: null,
      responseList: null,
    };
  }

  componentWillMount() {
    try {
      CSATService()
        .getCSATScoreForApp(this.state.reportAppId)
        .then((resp) => {
          this.setState({
            practiceScore: resp.practiceScore,
            providerScore: resp.providerScore,
            responseList: resp.responseList,
          });
        })
        .catch((err) => {});
    } catch (ex) {
      console.log(ex);
    }
  }

  componentWillReceiveProps(nextProps) {}

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }
    return (
      <AppFrame
        auth={this.props.auth}
        targetDevice={targetDevice}
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div>
          <Title
            text1="Client Satisfaction"
            text2="Report"
            goBack={() => this.props.history.goBack()}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
          <Icon />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <CSATScore
              whiteLabelSettings={this.props.whiteLabelSettings}
              title="Practice CSAT Score"
              score={this.state.practiceScore}
            />
            <CSATScore
              whiteLabelSettings={this.props.whiteLabelSettings}
              title="Provider CSAT Score"
              score={this.state.providerScore}
            />
          </div>
        </div>
        <div style={{ width: "75%", marginLeft: "auto", marginRight: "auto" }}>
          <CSATReport
            appId={this.state.reportAppId}
            reportData={this.state.responseList}
          />
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, whiteLabelSettings }) {
  return {
    user,
    apps,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CSATRatingView);



// WEBPACK FOOTER //
// ./src/layout/reporting/ChannelLevel/CSATRatingView.js